import { Farms } from "@farm/domain/models/farm.model";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { farmTypes } from "@farm/farm-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class FarmGetAllUseCase {
    constructor(
        @inject(farmTypes.repositories.FarmRepository)
        private readonly farmRepository: FarmRepository,
    ) {}

    async execute(): Promise<Farms> {
        const farmResult = await this.farmRepository.getAll();

        if (farmResult.isErr()) {
            throw new Error("Error getting farms");
        }

        return farmResult.match(
            (farms) => farms,
            () => Farms.empty(),
        );
    }
}
